export enum SearchType{
    Default,
    Direct,
    UserInitiated,
    Banner
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/search-types.model.ts